import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';

export const selectEmVatCorrectionsImport = (state: TStoreState) => state.emVatCorrectionsImport;

export const selectEmVatCorrectionsImportList = (state: TStoreState) =>
	selectEmVatCorrectionsImport(state).list;

export const selectEmVatCorrectionsImportListLoading = (state: TStoreState) =>
	selectEmVatCorrectionsImport(state).listLoading;

const EMPTY_ROWS: never[] = [];

export const selectEmVatCorrectionsImportListRows = createSelector(
	[selectEmVatCorrectionsImportList],
	(list) => list?.rows ?? EMPTY_ROWS,
);

export const selectEmVatCorrectionsImportListRowCount = (state: TStoreState) => {
	const list = selectEmVatCorrectionsImportList(state);
	return list?.rowCount ?? 0;
};

export const selectEmVatCorrectionsImportListPage = (state: TStoreState) => {
	const list = selectEmVatCorrectionsImportList(state);
	return list?.page ?? null;
};

export const selectOrderVatCorrectionsRows = (state: TStoreState) =>
	selectEmVatCorrectionsImport(state).orderDetailRows;

export const selectOrderVatCorrectionsLoading = (state: TStoreState) =>
	selectEmVatCorrectionsImport(state).orderDetailLoading;
